import { render, staticRenderFns } from "./PaginationNumbers.vue?vue&type=template&id=00b6a94d&"
import script from "./PaginationNumbers.vue?vue&type=script&lang=js&"
export * from "./PaginationNumbers.vue?vue&type=script&lang=js&"
import style0 from "./PaginationNumbers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports